import { lazy } from "react";

const ReleasePage = lazy(() => import("./ReleasePage"));

export { ReleasePage };
